import React, { JSX } from 'react';
import { observer } from 'mobx-react';
import PaxRoomSelectionController from './PaxRoomSelectionController';
import { Label } from 'reactstrap';
import { range } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import Keys from '../../Translations/generated/pax-room-selection.en.json.keys';
import { ReactSelectOption, Select } from '@ibe/components';
import NativeAgeSelect from './NativeAgeSelect';

const ChildAgePicker = observer(
  ({
    roomIndex,
    childIndex,
    childAgePlaceholder,
    maxChildAge,
    state,
    validateChildrenSelection,
    paxHasError,
    menuPortalTarget,
    onChange,
    newAgeSelect
  }: {
    roomIndex: number;
    childIndex: number;
    childAgePlaceholder?: string;
    maxChildAge?: number;
    state: PaxRoomSelectionController;
    validateChildrenSelection?: () => boolean;
    paxHasError?: boolean;
    menuPortalTarget?: HTMLElement;
    onChange?: (roomIndex: number, childIndex: number, newValue: ReactSelectOption) => void;
    newAgeSelect?: boolean;
  }): JSX.Element => {
    const { t } = useTranslation('pax-room-selection');
    const finalMaxChildAge = maxChildAge ? maxChildAge + 1 : state.defaultChildAgeLimit;

    const selectElemId = 'childAgePicker' + (childIndex + 1);

    return (
      <>
        <Label for={selectElemId} className="paxRoomSelection__child-age-picker__label">{`${t(
          Keys.ageCapitalized
        )} - ${t(Keys.child)} ${childIndex + 1}`}</Label>
        {newAgeSelect ? (
          <NativeAgeSelect
            roomIndex={roomIndex}
            childIndex={childIndex}
            state={state}
            childAgePlaceholder={childAgePlaceholder}
            maxChildAge={maxChildAge}
            onChange={onChange}
          />
        ) : (
          <Select
            placeholder={childAgePlaceholder}
            options={range(0, finalMaxChildAge).map(val => {
              return state.getChildAgeOption(val);
            })}
            selectedOption={
              state.rooms[roomIndex].childrenAges.length > childIndex &&
              !Number.isNaN(state.rooms[roomIndex].childrenAges[childIndex])
                ? state.getSelectedChildAgeOption(state.rooms[roomIndex].childrenAges[childIndex])
                : null
            }
            getLabel={(option): string => (option ? option.label : '')}
            getValue={(option): string => (option ? option.value : '')}
            onChange={(val): void =>
              onChange
                ? onChange(roomIndex, childIndex, val)
                : state.setChildAgeForRoom(roomIndex, childIndex, val)
            }
            isSearchable={false}
            menuPlacement={'auto'}
            menuPortalTarget={menuPortalTarget}
          />
        )}
      </>
    );
  }
);

export default ChildAgePicker;
